module.exports = __webpack_public_path__ + "img/oneGreen.5915c5d7.jpg";